@Inject('Notifications')
export class RwPrivacyPolicyController {
  showDialog() {
    this.Notifications.showComplexDialog({
      component: 'rwPrivacyPolicyDialog',
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/rw-privacy-policy-controller.js